<template lang="pug">
  .home-work-list
    el-table(
      :data="tableData"
      style="width: 100%"
    )
      el-table-column(
        prop="date"
        label="Дата"
        width="180"
      )

      el-table-column(
        prop="theme"
        label="Тема"
        width="180"
      )

      el-table-column(
        label="Текст"
      )
        template(slot-scope="scope")
          p.overflow(v-html="scope.row.homeWorkText")

      el-table-column(width="90" align="center")
        template(slot-scope="scope")
          el-button(
            icon="el-icon-view"
            round
            @click="openModal(scope.row.files, scope.row.homeWorkText)"
          )
</template>

<script>
  import camelizeKeys from '@/utils/camelizeKeys';
  import { mapMutations } from 'vuex';

  export default {
    name: 'HomeWorkList',

    props: {
      groupId: {
        type: String,
        default: ''
      },
    },

    data() {
      return {
        list: [],
        tableData: []
      }
    },

    watch: {
      groupId() {
        this.getHomeworks()
      }

    },

    async created() {
      this.getHomeworks()
    },

    methods: {
      ...mapMutations(["setModalData"]),

      async getHomeworks() {
        try {
          const { status, data: { themes } } = await this.axios.get(`api/journal/${this.$route.params.sid}/homework/${this.groupId}`);

          if (status === 200) {
            this.list = camelizeKeys(themes);
            this.fillTableData(camelizeKeys(themes));
          }
        } catch (error) {
          console.warn('Failed fetch [Presence/homeWorkList]', error);
        }
      },

      async openModal(files, title) {
        let obj = {
          name: "HomeWorkModal",
          data: { files, title, readOnly: true },
          title: 'Домашнее задание',
        };

        this.setModalData(obj);
      },

      fillTableData(data) {
        this.tableData = data.map(({ datetime, theme, type, id, homeWork }) => {
          return {
            date: this.$moment(datetime).format('DD.MM.YYYY'),
            theme,
            type,
            id,
            homeWorkText: homeWork.title,
            files: homeWork.files
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .home-work-list {
    .home-work-text-wrap {
      max-height: 80px;
    }

    .overflow {
      max-height: 80px;
      overflow: hidden;
    }
  }
</style>